import { generateAssetPath } from '../../utils/assetsHelpers';
import config from '../../config';
import downloadXlsxFile from '../../shared/xlsxExport/downloadXlsxFile';
import { generateXlsxTemplateForConnection } from '../../administration/beginningBalancesPage/generateXLSXTemplate';

export const generateAndDownloadXlsxTemplateForConnectionBatchProvision = async ({
  periodName,
  connectionName,
  connectionTemplateDetails,
  environmentSuffix,
}) => {
  const generatedTemplate = await generateXlsxTemplateForConnection({
    periodName,
    connectionTemplateDetails,
    environmentSuffix,
    templateUrl: generateAssetPath(config.templates.TRIAL_BALANCE),
  });

  downloadXlsxFile(`TLS_Trial_Balance_${periodName}_${connectionName}${environmentSuffix}`, generatedTemplate);
};
